import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Building2 } from 'lucide-react';

export const Route = createFileRoute('/admin-console/organisation-management/organisations')({
    staticData: {
        breadcrumb: {
            title: 'Organisations',
        },
        ui: {
            icon: Building2,
            menuDescription: 'View and manage all organisations',
        },
    },
    component: Outlet,
});
